(() => {
  const atmosphere = document.querySelector('.ll-product-hover-bg');
  if (!atmosphere || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const cache = new Map();
  let activeCard = null;
  let requestToken = 0;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function enhance([r, g, b]) {
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const sat = max - min;
    const lum = (r + g + b) / 3;
    const saturationBoost = sat < 35 ? 1.16 : 1.10;
    const targetLum = clamp(lum * 0.94, 38, 158);
    const scale = targetLum / Math.max(lum, 1);
    r = clamp((r - lum) * saturationBoost + lum, 0, 255) * scale;
    g = clamp((g - lum) * saturationBoost + lum, 0, 255) * scale;
    b = clamp((b - lum) * saturationBoost + lum, 0, 255) * scale;
    return [Math.round(clamp(r, 0, 255)), Math.round(clamp(g, 0, 255)), Math.round(clamp(b, 0, 255))];
  }

  function sampleImage(url) {
    if (cache.has(url)) return cache.get(url);
    const promise = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = canvas.height = 32;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, 32, 32);
          const data = ctx.getImageData(0, 0, 32, 32).data;
          let r = 0, g = 0, b = 0, weight = 0;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 100) continue;
            const pr = data[i], pg = data[i + 1], pb = data[i + 2];
            const max = Math.max(pr, pg, pb), min = Math.min(pr, pg, pb);
            const chroma = max - min;
            const lum = (pr + pg + pb) / 3;
            if (lum > 235 && chroma < 18) continue;
            if (lum < 15) continue;
            const w = 1 + chroma / 38;
            r += pr * w; g += pg * w; b += pb * w; weight += w;
          }
          if (!weight) resolve([38, 38, 38]);
          else resolve(enhance([r / weight, g / weight, b / weight]));
        } catch (_) { resolve([38, 38, 38]); }
      };
      img.onerror = () => resolve([38, 38, 38]);
      img.src = url;
    });
    cache.set(url, promise);
    return promise;
  }

  async function activate(card) {
    const url = card.dataset.llHoverImage;
    if (!url) return;
    activeCard = card;
    const token = ++requestToken;
    const rgb = await sampleImage(url);
    if (token !== requestToken || activeCard !== card) return;
    const light = rgb.map(v => Math.round(v + (255 - v) * .16));
    document.documentElement.style.setProperty('--ll-hover-rgb', rgb.join(', '));
    document.documentElement.style.setProperty('--ll-hover-rgb-light', light.join(', '));
    atmosphere.classList.add('is-active');
  }

  function deactivate(card) {
    if (activeCard !== card) return;
    activeCard = null;
    requestToken++;

    if (document.body?.dataset.llProductPageImage) {
      activateProductPage();
      return;
    }

    document.documentElement.style.setProperty('--ll-hover-rgb', '31, 32, 36');
    document.documentElement.style.setProperty('--ll-hover-rgb-light', '72, 75, 82');
    atmosphere.classList.remove('is-active');
  }

  async function activateProductPage() {
    const url = document.body?.dataset.llProductPageImage;
    if (!url) return;

    const token = ++requestToken;
    const rgb = await sampleImage(url);
    if (token !== requestToken) return;

    const light = rgb.map(v => Math.round(v + (255 - v) * .16));
    document.documentElement.style.setProperty('--ll-hover-rgb', rgb.join(', '));
    document.documentElement.style.setProperty('--ll-hover-rgb-light', light.join(', '));
    atmosphere.classList.add('is-active');
  }

  activateProductPage();

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest('product-card[data-ll-hover-image]');
    if (!card || card.contains(event.relatedTarget)) return;
    activate(card);
  });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest('product-card[data-ll-hover-image]');
    if (!card || card.contains(event.relatedTarget)) return;
    const nextCard = event.relatedTarget?.closest?.('product-card[data-ll-hover-image]');
    if (nextCard) {
      activate(nextCard);
    } else {
      deactivate(card);
    }
  });
})();
